<template>
    <div class="align-center">You have reached this page by accident, please check the url.</div>
</template>
<script>
export default {
    name: 'not-found'
};
</script>
<style>

</style>
